const context = require.context(".", true, /\.svg$/);
const obj: { [key: string]: any } = {};

context.keys().forEach((key: any) => {
  obj[key] = context(key);
});

export default obj;
